"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const all = () => document.cookie.split("; ").map(cookieStr => cookieStr.split("="));
const keys = () => all().map(([key]) => key);
const set = (key, value, maxAge, topLevelDomain = true) => {
    let domain = "";
    if (topLevelDomain) {
        domain = `domain=${window.location.hostname.split(".").slice(-2).join(".")}`;
    }
    document.cookie = `${key}=${value};max-age=${maxAge};path=/;${domain}`;
};
const clear = (key) => {
    set(key, "", 0, true);
    set(key, "", 0, false);
};
const get = (key) => all().filter(([k]) => k === key).map(([_key, value]) => value)[0];
exports.default = { all, keys, set, clear, get };
